import { render, staticRenderFns } from "./Course.vue?vue&type=template&id=01f5e70c"
import script from "./Course.vue?vue&type=script&lang=js"
export * from "./Course.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/SysClass-Web-App/SysClass-Web-App/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01f5e70c')) {
      api.createRecord('01f5e70c', component.options)
    } else {
      api.reload('01f5e70c', component.options)
    }
    module.hot.accept("./Course.vue?vue&type=template&id=01f5e70c", function () {
      api.rerender('01f5e70c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/sys/select/Course.vue"
export default component.exports